import { useNavigate, useParams } from 'react-router-dom';
import { useKonamiCode } from '@/hooks/useKonamiCode';
import { useState, useCallback } from 'react';
import { storageSet } from '@/utils/safe-storage';

/**
 * Global Konami code handler component.
 * Place this in App.tsx to enable the easter egg from any page.
 */
export default function KonamiCodeHandler() {
  const navigate = useNavigate();
  const { locale } = useParams();
  const [showFlash, setShowFlash] = useState(false);

  const navigateToEasterEgg = useCallback(() => {
    // Don't trigger if already on the easter egg page
    if (window.location.pathname.includes('/beyond-code')) {
      return;
    }

    // Save scroll position before navigating away from home page
    storageSet('session', 'homepage-scroll-position', window.scrollY.toString());

    setShowFlash(true);
    setTimeout(() => {
      navigate(`/${locale || 'en'}/beyond-code`);
    }, 500);
  }, [navigate, locale]);

  // Konami code activates easter egg
  useKonamiCode(navigateToEasterEgg);

  if (!showFlash) return null;

  return (
    <div className="fixed inset-0 bg-white dark:bg-black z-[9999] animate-pulse pointer-events-none" />
  );
}
